import React from "react"
import { Link } from "gatsby"

const GetConsultationButton = () => (
  <Link className="btn btn-secondary" to="/chat">
    Let's talk
  </Link>
)

export default GetConsultationButton